import React, { createContext, useContext, useState, ReactNode, useCallback } from 'react';

interface BreadcrumbOverride {
  path: string;
  title: string;
}

interface BreadcrumbContextType {
  breadcrumbOverrides: BreadcrumbOverride[];
  setBreadcrumbOverrides: (overrides: BreadcrumbOverride[]) => void;
  clearBreadcrumbOverrides: () => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextType | undefined>(undefined);

interface BreadcrumbProviderProps {
  children: ReactNode;
}

export const BreadcrumbProvider: React.FC<BreadcrumbProviderProps> = ({ children }) => {
  const [breadcrumbOverrides, setBreadcrumbOverrides] = useState<BreadcrumbOverride[]>([]);

  const clearBreadcrumbOverrides = useCallback(() => {
    setBreadcrumbOverrides([]);
  }, []);

  const setBreadcrumbOverridesCallback = useCallback((overrides: BreadcrumbOverride[]) => {
    setBreadcrumbOverrides(overrides);
  }, []);

  return (
    <BreadcrumbContext.Provider value={{
      breadcrumbOverrides,
      setBreadcrumbOverrides: setBreadcrumbOverridesCallback,
      clearBreadcrumbOverrides
    }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumb = () => {
  const context = useContext(BreadcrumbContext);
  if (context === undefined) {
    throw new Error('useBreadcrumb must be used within a BreadcrumbProvider');
  }
  return context;
}; 